import { Component, OnInit } from '@angular/core';
import { LoadingFileService } from './services/loading-file.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showLoadingFile: boolean;
  title = '';

  constructor(private loadingFile: LoadingFileService) {

  }

  ngOnInit() {
    this.initLoadingService();
  }

  private initLoadingService() {
    this.loadingFile.currentLoading.subscribe(loading => {
      this.showLoadingFile = loading;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts